export default {
  title: "Person/Company registration",
  subtitle: "Overview",
  path: "person_company_registration",
  paragraphs: ["All pay-in and pay-out transactions within FacilitaPay must be associated with a customer, either a person or a company. This ensures that their internal ID, called subject_id, can be used as a reference for future transactions"],
  request: {},
}


// WEBPACK FOOTER //
// ./src/components/documentation/data/SubjectPeople/PersonCompanyIntroduction.js